// src/SilentGate.js  (또는 .tsx)
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Loading from "./components/Loading";

export default function SilentGate({ children }) {
  const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  // � Hook 은 항상 호출돼야 하므로 return 문보다 위에 둔다
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // 페이지를 떠나지 않는 silent 인증 시도. 성공하면 isAuthenticated 가
      // 뒤집혀 "/" 가 대시보드로 넘어가고, 실패(login_required 등)하면 조용히
      // 무시되어 로그인 게이트(LoginPage)가 그대로 남는다.
      // 이전 구현은 loginWithRedirect 전체 리다이렉트였는데, prompt:"none" 을
      // 최상위에 둬서 실제로는 일반 로그인 이동이 무조건 일어났고(옵션은
      // authorizationParams 안에 있어야 반영됨) 게이트 화면이 노출될 수 없었다.
      getAccessTokenSilently().catch(() => {
        /* 미로그인 → LoginPage 노출 */
      });
      // ① Confluence SP-initiated SAML 엔드포인트 사전 호출 (기존 동작 유지)
      fetch("https://mars-workplace.atlassian.net/plugins/servlet/samlsso", {
        mode: "no-cors",
        credentials: "include",
      });
    }
  }, [isLoading, isAuthenticated, getAccessTokenSilently]);

  // ↙ 이제 조건부 return 을 해도 Hook 순서가 변하지 않음
  if (isLoading) return <Loading />;
  return children;
}
